
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef } from 'react';
import SvgClose from '../../icons/legacy/close.svg.js';
import Tooltip from '../Tooltip/Tooltip.js';
import { useIsOverflowX } from './helpers.js';
import { chip } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["size", "onClose", "children", "icon", "style", "closeButtonAriaLabel", "maxWidth"];
var Chip = function Chip(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    onClose = _ref.onClose,
    children = _ref.children,
    Icon = _ref.icon,
    style = _ref.style,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? "Close filter" : _ref$closeButtonAriaL,
    maxWidth = _ref.maxWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isFilterOn = Boolean(Icon);
  var componentRef = useRef(null);
  var isOverflow = useIsOverflowX(componentRef);
  return jsx("div", _extends({
    css: function css(theme) {
      var _ref2;
      return chip(theme, {
        size: size,
        isFilterOn: isFilterOn,
        maxWidth: (_ref2 = "".concat(maxWidth, "px")) !== null && _ref2 !== void 0 ? _ref2 : "auto"
      });
    },
    style: style
  }, rest), onClose && jsx("button", {
    "data-testid": "close-filter",
    onClick: onClose,
    "aria-label": closeButtonAriaLabel,
    style: {
      color: style === null || style === void 0 ? void 0 : style.color
    }
  }, Icon && jsx(Icon, {
    className: "icon",
    "data-testid": "icon"
  }), jsx("span", {
    className: "close-icon"
  }, jsx(SvgClose, {
    height: 16
  }))), jsx(Tooltip, {
    content: children,
    disabled: !isOverflow
  }, jsx("div", {
    ref: componentRef,
    className: "has-overflow"
  }, children)));
};

export { Chip as default };
//# sourceMappingURL=Chip.js.map
